import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BylawsComponent } from './bylaws/bylaws.component';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../services/auth/auth.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AddNewBylawsComponent } from './add-new-bylaws/add-new-bylaws.component';
import { AmendmentsHistoryComponent } from './amendments-history/amendments-history.component';
import { NewAmendmentsComponent } from './new-amendments/new-amendments.component';
import { bylawsGuard } from '../services/auth/guards/bylaws.guard';
import { ReadMoreComponent } from '../component/read-more/read-more.component';
import { Bylaws2006Component } from './bylaws2006/bylaws2006.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CertificateComponent } from './certificate/certificate.component';
import { QRCodeComponent } from 'angularx-qrcode';

const routes: Routes = [
  {
    path: "",
    data: {
      title: "ByLaws",
      urls: [{ title: "ByLaws", url: "/bylaws" }, { title: "ByLaws" }],
    },
    component: BylawsComponent,
  },
  // { path: 'bylaws', component: BylawsComponent },
  { path: 'addbylaws', 
    // canActivate: [bylawsGuard],
     component: AddNewBylawsComponent },
  { path: 'NewAmendments', component: NewAmendmentsComponent, 
    // canActivate: [bylawsGuard] 
  },
  { path: 'NewAmendments/:id', component: NewAmendmentsComponent
    // , canActivate: [bylawsGuard] 
  },
  { path: 'amendmentsHistory', component: AmendmentsHistoryComponent, 
    // canActivate: [bylawsGuard] 
  },
  { path: 'bylaws2006', component: Bylaws2006Component },

];

@NgModule({
  declarations: [
    BylawsComponent,
    AddNewBylawsComponent,
    AmendmentsHistoryComponent,
    NewAmendmentsComponent,
    Bylaws2006Component,
    CertificateComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxDatatableModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    ReadMoreComponent,
    QRCodeComponent,
    NgMultiSelectDropDownModule
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class BylawsModule { }
